import {
  withCompInfo,
  createComponentMapperModel,
  withStateRefsValues,
} from '@wix/editor-elements-integrations';
import type {
  IVerticalLineProps,
  VerticalLineDefinition,
} from '../VerticalLine.types';

/**
 * This mapper makes sure verticalLine will be affected by the css editing mappers
 */
export const props = withCompInfo<
  IVerticalLineProps,
  VerticalLineDefinition,
  IVerticalLineProps
>()([], (_, carmiData) => {
  return {
    ...carmiData,
  };
});

export const stateRefs = withStateRefsValues(['experiments']);

export default createComponentMapperModel({ props, stateRefs });
